import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {from, Observable, throwError} from 'rxjs';
import {MapaEnviromentService} from '@mapa/core';
import {ControleAcessoSgsia} from '../../../model/sgsia/controle-acesso-sgsia';
import {RespostaPaginada} from '../../../model/sgsia/paginacao-sgsia';
import {ControleAcessoFiltroSgsia} from '../../../model/sgsia/controle-acesso-filtro-sgsia';

export interface IHistorico {
    cdPerfil: string;
    idControleAcesso: number;
    idHistoricoControleAcesso: number;
    nmPerfil: string;
    dataHistorico: string | Date,
    objeto: string;
    objetoAnterior: string;
    tipoAcao: string;
}
@Injectable({
    providedIn: 'root'
})
export class ControleAcessoService {
    private apiUrl: any;

    constructor(private http: HttpClient) {
        MapaEnviromentService.get((config: any) => {
            if (config.ambiente === 'Local') {
                this.apiUrl = config.localUrl + '/api/v1';
            } else {
                this.apiUrl = config.wso2Url + 'sgsia/1.0.0/api/v1';
            }
        });
    }

    consultar(filtro: ControleAcessoFiltroSgsia): Observable<RespostaPaginada<ControleAcessoSgsia>> {
        const url = this.apiUrl.concat(`/controle-acesso`);
        const solicitacaoPromise = this.http.get(url, { params: filtro.getAsHTTPParams() || null});
        return from(solicitacaoPromise).pipe(
            map((item: any) => {
                item.conteudo = this.jsonDataToResources(item.conteudo);
                return item;
            }),
            catchError(this.handleError)
        );
    }

    /**
     * Inclui uma solicitacao de acesso
     */
    save(data: any): Observable<any> {
        const urlWithParameter = this.apiUrl.concat('/controle-acesso');
        return this.http.post<any>(urlWithParameter, data).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * Inclui uma solicitacao de acesso
     */
    remover(id: any, justificativa): Observable<any> {
        const urlWithParameter = this.apiUrl.concat('/controle-acesso/' + id);
        return this.http.request<any>('delete',urlWithParameter, { body : { justificativaGestor: justificativa}}).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * Inclui uma solicitacao de acesso
     */
    update(data: ControleAcessoSgsia): Observable<any> {
        const urlWithParameter = this.apiUrl.concat(`/controle-acesso/${data.idControleAcesso}`);
        return this.http.put<any>(urlWithParameter, data).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * Aprova uma solicitacao de acesso
     */
    aprovar(data: ControleAcessoSgsia): Observable<any> {
        const urlWithParameter = this.apiUrl.concat(`/controle-acesso/${data.idControleAcesso}/aprovar`);
        return this.http.put<any>(urlWithParameter, data).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * Reprovar uma solicitacao de acesso
     */
    reprovar(data: ControleAcessoSgsia): Observable<any> {
        const urlWithParameter = this.apiUrl.concat(`/controle-acesso/${data.idControleAcesso}/reprovar`);
        return this.http.put<any>(urlWithParameter, data).pipe(
            catchError(this.handleError)
        );
    }

    getById(idControleAcesso: (number | string)): Observable<ControleAcessoSgsia> {
        const urlWithParameter = this.apiUrl.concat(`/controle-acesso/${idControleAcesso}`);
        const solicitacaoPromise = this.http.get(urlWithParameter)
        return from(solicitacaoPromise).pipe(
            map((item: any) => {
                return this.jsonDataToResource(item.conteudo);
            }),
            catchError(this.handleError)
        );
    }

    /**
     * Remove um fornecedor
     */
    remove(id: number): Observable<any> {
        const urlWithParameter = this.apiUrl.concat(`/controle-acesso/${id}`);
        return this.http.delete<any>(urlWithParameter).pipe(
            catchError(this.handleError)
        );
    }

    ativar(id: any) {
        const urlWithParameter = this.apiUrl.concat(`/controle-acesso/${id}/ativar`);
        return this.http.put<any>(urlWithParameter, {}).pipe(
            catchError(this.handleError)
        );
    }

    desativar(id: any) {
        const urlWithParameter = this.apiUrl.concat(`/controle-acesso/${id}/inativar`);
        return this.http.put<any>(urlWithParameter, {}).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * Transforma json em instancia
     */
    private jsonDataToResources(jsonData: Array<any>): ControleAcessoSgsia[] {
        const data = jsonData || [];
        return data.map(this.jsonDataToResource);
    }

    /**
     * Transforma json em instancia
     */
    protected jsonDataToResource(jsonData: any): ControleAcessoSgsia {
        return ControleAcessoSgsia.fromJson(jsonData);
    }

    /**
     * Exibe mensagem no console
     */
    protected handleError(error: any): Observable<any> {
        console.log('ERROR NA REQUISIÇÃO => ', error);
        return throwError(error.error);
    }

    getByHistoricoId(idControleAcesso: string) {
        const urlWithParameter = this.apiUrl.concat(`/controle-acesso/${idControleAcesso}/historico`);
        const solicitacaoPromise = this.http.get(urlWithParameter)
        return from(solicitacaoPromise).pipe(
            map((item: any) => {
                return item.conteudo as IHistorico[];
            }),
            catchError(this.handleError)
        );
    }
}
